module.exports = __webpack_public_path__ + "static/media/add_circle-24px.a1a53e3d.svg";